export const BRAND_NAME = 'SkyThunders';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'skythunders.com';
export const PROVIDER_ID = 'BetFair';
